export default __webpack_public_path__ + "static/media/Visual.f91c087c.jpg";